<div class="form-modal {{rootClass}}" id="choose-modal">
  <h1 mat-dialog-title>{{ modalTitle | translate}}</h1>
  <div mat-dialog-content>
    <div class="form-horizontal">
      <div class="row" *ngIf="filterDate">
        <form [formGroup]="form" class="form-horizontal">
          <div class="col-sm-4">
            <mat-form-field class="allwidth" >
              <input matInput placeholder="{{ 'BEGIN_DATE' | translate}}" 
                class="one date-picker"  formControlName="dataInicio">
                <i matSuffix class="far fa-calendar-alt bigger-110"></i>
            </mat-form-field>
          </div>
          <div class="col-sm-4">
            <mat-form-field class="allwidth" >
              <input matInput placeholder="{{ 'END_DATE' | translate}}"
                class="one date-picker"  formControlName="dataFim">
                <i matSuffix class="far fa-calendar-alt bigger-110"></i>
            </mat-form-field>
          </div>
          <div class="col-sm-4">
            <button type="button" class="btn btn-default" (click)="onClickFilterDates()" [disabled]="form.invalid">
              <i class="fas fa-search iconSearch"></i>
              &nbsp;{{ 'BUTTON.SEARCH' | translate }}
            </button>
          </div>
        </form>
      </div>
      <div class="row">

        <div class="col-sm-12">
          <table id="tableChoose" class="table table-bordered display" cellspacing="0" cdkFocusInitial tabindex="0">
            <thead>
              <tr></tr>
              <!-- Titulos colunas -->
              <tr></tr>
              <!-- Input de filtros de colunas -->
            </thead>
            <tbody></tbody>
          </table>
        </div>

      </div>
    </div>
  </div>
  <div mat-dialog-actions>
    <div class="col-md-12 no-padding text-right modal-theme">
      <button type="button" class="btn btn-default" title="{{'BUTTON.CANCEL' | translate}}" (click)="cancel()">
        {{'BUTTON.CANCEL' | translate}}
      </button>
      
      <button *ngIf="allowNone" type="button" class="btn btn-default" title="{{'BUTTON.CLEAR' | translate}}" (click)="removerSeleccao()">
        {{'BUTTON.CLEAR' | translate}}
      </button>
    </div>
  </div>
</div>